import { getSalesStartOnboardingCookie } from './getSalesStartOnboardingCookie';
import { ONBOARDING_DISPLAY_LIMIT } from '../../constants/salesStartOnboarding';

export function isSalesStartOnboardingShown() {
  const timesSalesStartOnboardingShown = getSalesStartOnboardingCookie();

  return timesSalesStartOnboardingShown >= ONBOARDING_DISPLAY_LIMIT;
}
